import { render, staticRenderFns } from "./PackagePlanBoxes.vue?vue&type=template&id=8f9a66e6"
import script from "./PackagePlanBoxes.vue?vue&type=script&lang=js"
export * from "./PackagePlanBoxes.vue?vue&type=script&lang=js"
import style0 from "./PackagePlanBoxes.vue?vue&type=style&index=0&id=8f9a66e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports